import { render, staticRenderFns } from "./SkeletonTable.vue?vue&type=template&id=6ae9d1c0&"
import script from "./SkeletonTable.vue?vue&type=script&lang=js&"
export * from "./SkeletonTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports